<template>
  <v-card elevation="0">
    <v-card-title class="pa-0">
      <v-card-actions>
        <v-btn
          icon
          small
          @click="showCard = !showCard"
        >
          <v-icon>{{ showCard ? 'fas fa-minus' : 'fas fa-plus' }}</v-icon>
        </v-btn>
      </v-card-actions>
      {{title}}
    </v-card-title>

    <v-expand-transition>
      <div v-show="showCard">
        <v-card-text>

          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left col-1">Faixa Etária</th>
                <th class="text-center col-1">Titulares Feminino</th>
                <th class="text-center col-1">Titulares Masculino</th>
                <th class="text-center col-1">Dependentes Legais Feminino</th>
                <th class="text-center col-1">Dependentes Legais Masculino</th>
                <th class="text-center col-1">Agregados Feminino</th>
                <th class="text-center col-1">Agregados Masculino</th>
                <th class="text-center col-1">Demitidos e Aposentados Feminino</th>
                <th class="text-center col-1">Demitidos e Aposentados Masculino</th>
                <th class="text-center col-1">Afastados Feminino</th>
                <th class="text-center col-1">Afastados Masculino</th>
                <th class="text-center col-2">Total</th>
                <th class="text-center col-1" v-if="showDistribution">Distrib.%</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in generalAgeGroup"
                  :key="item.ageGroup">
                <td style="white-space: pre;">{{ item.ageGroup }}</td>
                <td style="text-align: center">
                  <v-text-field v-model="item.femaleHolders" class="centered-input" v-mask="$util.formmasks.number"
                                 @keyup="sumTotalPeople(item,'femaleHolders')"></v-text-field>
                </td>
                <td style="text-align: center">
                  <v-text-field v-model="item.maleHolders" class="centered-input" v-mask="$util.formmasks.number"
                                @keyup="sumTotalPeople(item,'maleHolders')"></v-text-field>
                </td>
                <td style="text-align: center">
                  <v-text-field v-model="item.femaleLegalDependent" class="centered-input" v-mask="$util.formmasks.number"
                                @keyup="sumTotalPeople(item,'femaleLegalDependent')"></v-text-field>
                </td>
                <td style="text-align: center">
                  <v-text-field v-model="item.maleLegalDependent" class="centered-input" v-mask="$util.formmasks.number"
                                @keyup="sumTotalPeople(item,'maleLegalDependent')"></v-text-field>
                </td>
                <td style="text-align: center">
                  <v-text-field v-model="item.femaleHouseHold" class="centered-input" v-mask="$util.formmasks.number"
                                @keyup="sumTotalPeople(item,'femaleHouseHold')"></v-text-field>
                </td>
                <td style="text-align: center">
                  <v-text-field v-model="item.maleHouseHold" class="centered-input" v-mask="$util.formmasks.number"
                                @keyup="sumTotalPeople(item,'maleHouseHold')"></v-text-field>
                </td>
                <td style="text-align: center">
                  <v-text-field v-model="item.femaleFiredOrRetiree" class="centered-input" v-mask="$util.formmasks.number"
                                @keyup="sumTotalPeople(item,'femaleFiredOrRetiree')"></v-text-field>
                </td>
                <td style="text-align: center">
                  <v-text-field v-model="item.maleFiredOrRetiree" class="centered-input" v-mask="$util.formmasks.number"
                                @keyup="sumTotalPeople(item,'maleFiredOrRetiree')"></v-text-field>
                </td>
                <td style="text-align: center">
                  <v-text-field v-model="item.femaleInactive" class="centered-input" v-mask="$util.formmasks.number"
                                @keyup="sumTotalPeople(item,'femaleInactive')"></v-text-field>
                </td>
                <td style="text-align: center">
                  <v-text-field v-model="item.maleInactive" class="centered-input" v-mask="$util.formmasks.number"
                                @keyup="sumTotalPeople(item,'maleInactive')"></v-text-field>
                </td>
                <td style="text-align: center">
                  
                  <span v-if="showDistribution && index==0" :class="item.overall>totalHealthCarePlanAgeGroup.untilEighteenPeople ? 'red--text' : ''">{{item.overall}} / {{totalHealthCarePlanAgeGroup.untilEighteenPeople}}</span>
                  <span v-if="showDistribution && index==1" :class="item.overall>totalHealthCarePlanAgeGroup.nineteenToTwentyThreePeoples ? 'red--text' : ''">{{item.overall}} / {{totalHealthCarePlanAgeGroup.nineteenToTwentyThreePeoples}}</span>
                  <span v-if="showDistribution && index==2" :class="item.overall>totalHealthCarePlanAgeGroup.twentyFourToTwentyEightPeoples ? 'red--text' : ''">{{item.overall}} / {{totalHealthCarePlanAgeGroup.twentyFourToTwentyEightPeoples}}</span>
                  <span v-if="showDistribution && index==3" :class="item.overall>totalHealthCarePlanAgeGroup.twentyNineToThirtyThreePeoples ? 'red--text' : ''">{{item.overall}} / {{totalHealthCarePlanAgeGroup.twentyNineToThirtyThreePeoples}}</span>
                  <span v-if="showDistribution && index==4" :class="item.overall>totalHealthCarePlanAgeGroup.thirtyFourToThirtyEightPeoples ? 'red--text' : ''">{{item.overall}} / {{totalHealthCarePlanAgeGroup.thirtyFourToThirtyEightPeoples}}</span>
                  <span v-if="showDistribution && index==5" :class="item.overall>totalHealthCarePlanAgeGroup.thirtyNineToFortyThreePeoples ? 'red--text' : ''">{{item.overall}} / {{totalHealthCarePlanAgeGroup.thirtyNineToFortyThreePeoples}}</span>
                  <span v-if="showDistribution && index==6" :class="item.overall>totalHealthCarePlanAgeGroup.fortyFourToFortyEightPeoples ? 'red--text' : ''">{{item.overall}} / {{totalHealthCarePlanAgeGroup.fortyFourToFortyEightPeoples}}</span>
                  <span v-if="showDistribution && index==7" :class="item.overall>totalHealthCarePlanAgeGroup.fortyNineToFiftyThreePeoples ? 'red--text' : ''">{{item.overall}} / {{totalHealthCarePlanAgeGroup.fortyNineToFiftyThreePeoples}}</span>
                  <span v-if="showDistribution && index==8" :class="item.overall>totalHealthCarePlanAgeGroup.fiftyFourToFiftyEightPeoples ? 'red--text' : ''">{{item.overall}} / {{totalHealthCarePlanAgeGroup.fiftyFourToFiftyEightPeoples}}</span>
                  <span v-if="showDistribution && index==9" :class="item.overall>totalHealthCarePlanAgeGroup.fromFiftyNinePeoples ? 'red--text' : ''">{{item.overall}} / {{totalHealthCarePlanAgeGroup.fromFiftyNinePeoples}}</span>
                  <span v-if="!showDistribution" >{{item.overall}}</span>
                </td>
                <td style="text-align: center" v-if="showDistribution">
                  {{item.distribution}}%
                </td>
              </tr>
              <tr>
                <td>Total</td>
                <td style="text-align: center">
                  {{totalAgeGroupTable.femaleHolders}}
                </td>
                <td style="text-align: center">
                  {{totalAgeGroupTable.maleHolders}}
                </td>
                <td style="text-align: center">
                  {{totalAgeGroupTable.femaleLegalDependent}}
                </td>
                <td style="text-align: center">
                  {{totalAgeGroupTable.maleLegalDependent}}
                </td>
                <td style="text-align: center">
                  {{totalAgeGroupTable.femaleHouseHold}}
                </td>
                <td style="text-align: center">
                  {{totalAgeGroupTable.maleHouseHold}}
                </td>
                <td style="text-align: center">
                  {{totalAgeGroupTable.femaleFiredOrRetiree}}
                </td>
                <td style="text-align: center">
                  {{totalAgeGroupTable.maleFiredOrRetiree}}
                </td>
                <td style="text-align: center">
                  {{totalAgeGroupTable.femaleInactive}}
                </td>
                <td style="text-align: center">
                  {{totalAgeGroupTable.maleInactive}}
                </td>
                <td style="text-align: center">
                  <span v-if="showDistribution" :class="totalAgeGroupTable.overall>totalHealthCarePlanAgeGroup.overall ? 'red--text' : ''">{{totalAgeGroupTable.overall}} / {{totalHealthCarePlanAgeGroup.overall}}</span>
                  <span v-if="!showDistribution" >{{totalAgeGroupTable.overall}}</span>
                </td>
                <td style="text-align: center" v-if="showDistribution">
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <span v-if="showAggregatePeoplesPercentage">Percentual de Agregados: {{ aggregatePeoples }}%</span>
         
         <Title title="Beneficiários com idade igual ou maior a 59 anos"></Title>
          É necessário preencher a distribuição de faixa etária de vidas sem plano para adicionar beneficiários com idade igual ou maior a 59 anos.
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import Title from "@/components/structure/title"

export default {
  components: {Title},
  props:{
    generalAgeGroup: {
      type: []
    },
    title:{
      type: String
    },
    showDistribution:{
      type: Boolean
    },
    showAggregatePeoplesPercentage:{
      type: Boolean
    },
    totalHealthCarePlanAgeGroup:{
      type: Object
    },
  },
  data(){
    return {
      showCard: true,
      totalAgeGroupTable:{
        femaleHolders: 0,
        maleHolders: 0,
        femaleLegalDependent: 0,
        maleLegalDependent: 0,
        femaleHouseHold: 0,
        maleHouseHold:0,
        femaleFiredOrRetiree: 0,
        maleFiredOrRetiree:0,
        femaleInactive:0,
        maleInactive:0,
        overall: 0
      }
    }
  },
  methods:{
    sumTotalPeople(item,ageGroup){
      item.overall=0;
      item.overall+=parseInt(item.femaleHolders?item.femaleHolders:0);
      item.overall+=parseInt(item.maleHolders?item.maleHolders:0);
      item.overall+=parseInt(item.femaleLegalDependent?item.femaleLegalDependent:0);
      item.overall+=parseInt(item.maleLegalDependent?item.maleLegalDependent:0);
      item.overall+=parseInt(item.femaleHouseHold?item.femaleHouseHold:0);
      item.overall+=parseInt(item.maleHouseHold?item.maleHouseHold:0);
      item.overall+=parseInt(item.femaleFiredOrRetiree?item.femaleFiredOrRetiree:0);
      item.overall+=parseInt(item.maleFiredOrRetiree?item.maleFiredOrRetiree:0);
      item.overall+=parseInt(item.femaleInactive?item.femaleInactive:0);
      item.overall+=parseInt(item.maleInactive?item.maleInactive:0);
      this.totalAgeGroupTable[ageGroup]=0;
      this.generalAgeGroup.filter((group, index) => group[ageGroup]).forEach((group, index) => {
        this.totalAgeGroupTable[ageGroup] += parseInt(group[ageGroup]);
      });
      this.sumTotalOverall();
      this.generalAgeGroup.forEach(group=>{
        
        group.distribution = group.overall==0 ? 0 : ((group.overall * 100) / this.totalAgeGroupTable.overall).toFixed(2);
      });
    },
    sumTotalOverall(){
      this.totalAgeGroupTable.overall=0;
      this.totalAgeGroupTable.overall+=this.totalAgeGroupTable.femaleHolders;
      this.totalAgeGroupTable.overall+=this.totalAgeGroupTable.maleHolders;
      this.totalAgeGroupTable.overall+=this.totalAgeGroupTable.femaleLegalDependent;
      this.totalAgeGroupTable.overall+=this.totalAgeGroupTable.maleLegalDependent;
      this.totalAgeGroupTable.overall+=this.totalAgeGroupTable.femaleHouseHold;
      this.totalAgeGroupTable.overall+=this.totalAgeGroupTable.maleHouseHold;
      this.totalAgeGroupTable.overall+=this.totalAgeGroupTable.femaleFiredOrRetiree;
      this.totalAgeGroupTable.overall+=this.totalAgeGroupTable.maleFiredOrRetiree;
      this.totalAgeGroupTable.overall+=this.totalAgeGroupTable.femaleInactive;
      this.totalAgeGroupTable.overall+=this.totalAgeGroupTable.maleInactive;
    },
  },
  computed: {
    aggregatePeoples() {
      return (this.totalAgeGroupTable.femaleHouseHold+this.totalAgeGroupTable.maleHouseHold)>0 ? (((this.totalAgeGroupTable.femaleHouseHold+this.totalAgeGroupTable.maleHouseHold)*100)/this.totalAgeGroupTable.overall).toFixed(2) : 0;
    },
  },
  mounted(){
    if(this.generalAgeGroup.length>0){
      this.generalAgeGroup.forEach(item => {
        this.sumTotalPeople(item,'femaleHolders');
        this.sumTotalPeople(item,'maleHolders');
        this.sumTotalPeople(item,'femaleLegalDependent');
        this.sumTotalPeople(item,'maleLegalDependent');
        this.sumTotalPeople(item,'femaleHouseHold');
        this.sumTotalPeople(item,'maleHouseHold');
        this.sumTotalPeople(item,'femaleFiredOrRetiree');
        this.sumTotalPeople(item,'maleFiredOrRetiree');
        this.sumTotalPeople(item,'femaleInactive');
        this.sumTotalPeople(item,'maleInactive');
      });
    }
  },
  name: "include_age_group_table"
}
</script>

<style scoped>
.centered-input >>> input {
  text-align: center
}
</style>
